<template>
  <div class="upgradetopracticemodalmessage" @click="onClose({status:false})">
    <div class="upgradetopremium">
      <div class="upgradetopremiummodal">
        <div class="sorry-title" v-if="data && data.title">{{ data.title }}</div>
        <div class="modal-text">{{ data && data.message ? data.message : '' }}</div>
        <div>
          <v-btn color="#EEBC1D" class="yellow-btn" @click="onClose({status:false})">
            OK
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssignmentPopup",
  props: ["onClose", "status", "data"],
};
</script>

<style scoped>
.upgradetopracticemodalmessage {
  position: fixed;
  background: rgba(0, 0, 0, 0.32);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upgradetopremium {
  width: 450px;
}

.upgradetopremiummodal {
  padding: 30px 15px 15px;
  border-radius: 10px !important;
  background: #fff;
  text-align: center;
}

.modal-text {
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.sorry-title {
  color: #dc665b;
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  margin-bottom: 5px;
}

.yellow-btn {
  width: 280px;
  margin-top: 3px;
  margin-bottom: 0;
}
</style>
